import { render, staticRenderFns } from "./MenusListAddNew.vue?vue&type=template&id=3c401a51&"
import script from "./MenusListAddNew.vue?vue&type=script&lang=js&"
export * from "./MenusListAddNew.vue?vue&type=script&lang=js&"
import style0 from "./MenusListAddNew.vue?vue&type=style&index=0&id=3c401a51&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports